import { configureApiEntity } from '../adapter/index';
import { schema } from 'normalizr';

export const priceZonesSchema = new schema.Entity('priceZones');

export const priceZones = configureApiEntity('PRICEZONES', 'pricezones', priceZonesSchema);
